import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FaqCommentsSection from '@/pages/home/components/FaqCommentsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FeaturesAboutSection from '@/pages/home/components/FeaturesAboutSection';
import TopicsRankingSection from '@/pages/home/components/TopicsRankingSection';
import IndexMediaSection from '@/pages/home/components/IndexMediaSection';
import AppSection from '@/pages/home/components/AppSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <FaqCommentsSection />
        <CarouselSection />
        <FeaturesAboutSection />
        <TopicsRankingSection />
        <IndexMediaSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}